import Packages from '@/module/renew/packages';
import Purchase from '@/module/renew/purchase';
import Upgrade from '@/module/renew/upgrade';
import Pay from '@/module/renew/pay';
import PayResult from '@/module/renew/payResult';

export default {
  routes: [
    {
      path: '/renew/packages',
      name: 'renew_packages',
      component: () => import('@/module/renew/packages.vue'),
      meta: {
        title: '服务订购',
        keepAlive: false,
        logined: false
      }
    },
    {
      path: '/renew/purchase',
      name: 'renew_purchase',
      component: () => import('@/module/renew/purchase.vue'),
      meta: {
        title: '购买套餐',
        keepAlive: false,
        logined: false
      }
    },
    {
      path: '/renew/upgrade',
      name: 'renew_upgrade',
      component: () => import('@/module/renew/upgrade.vue'),
      meta: {
        title: '升级套餐',
        keepAlive: false,
        logined: false
      }
    },
    {
      path: '/renew/pay',
      name: 'renew_pay',
      component: () => import('@/module/renew/pay.vue'),
      meta: {
        title: '支付订单',
        keepAlive: false,
        logined: false
      }
    },
    {
      path: '/renew/payresult',
      name: 'renew_payresult',
      component: () => import('@/module/renew/payResult.vue'),
      meta: {
        title: '支付订单',
        keepAlive: false,
        logined: false
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/Renew.js